import { useEffect, useMemo, useState } from 'react';
import Select from '@Common/Select';
import { Section } from '@Models/types';
import { useTestCaseContext } from '@Context/TestCaseContext';

const Sections = () => {
  const {
    sections,
    selectedSection,
    selectedProject,
    fetchSections,
    setSelectedSection,
  } = useTestCaseContext();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (selectedProject) {
      setLoading(true);
      fetchSections(selectedProject.id).then(() => setLoading(false));
    }
  }, [selectedProject]);

  useEffect(() => {
    if (selectedProject) {
      setError(null);
      setSelectedSection(null);
    }
  }, [selectedProject]);

  const sectionOptions = useMemo(() => {
    return sections.map((section) => ({
      label: section.name,
      value: section,
    }));
  }, [sections]);

  const handleSectionChange = (
    selected: { label: string; value: Section } | null
  ) => {
    if (selected) {
      setSelectedSection(selected.value);
    }
  };

  const handleClick = () => {
    if (!selectedProject) {
      setError('Select a project first');
    }
  };

  const placeholder = loading
    ? 'Loading Sections'
    : selectedSection
      ? selectedSection.name
      : 'Select TestRail Section';

  return (
    <div className="flex flex-col gap-y-2" onClick={() => handleClick()}>
      <div className="mt-2 flex flex-row items-center text-xl font-bold">
        <label className="text-primary-700">Sections</label>
      </div>
      <div className="flex flex-col items-start gap-y-2">
        <Select
          disabled={!selectedProject || loading}
          type="TestRail Section"
          loading={loading}
          options={loading ? [] : sectionOptions}
          onChange={handleSectionChange}
          placeholder={placeholder}
        />
        {error && (
          <div className="animate-pulse px-4 text-sm font-bold text-red-500">
            {error}
          </div>
        )}
      </div>
    </div>
  );
};

export default Sections;
